export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["MAGAZINE"] = "Magazine";
  TabHeaders["NEWSPAPER"] = "Newspaper";
  TabHeaders["ONLINE"] = "Online";
  TabHeaders["TV_RADIO"] = "TV/Radio";
})(TabHeaders || (TabHeaders = {}));